<template>
  <div :class="['mbo', {'mbo--admin': admin}]">
    <MbSceneIntro v-if="scene === 'intro'" :battle="battle" :series="series" :title="title"/>
    <template v-else-if="scene === 'draft' || scene === 'game' || scene === 'post'">
      <MbSceneDraft v-if="scene === 'draft' && battle" :battle="battle"/>
      <MbSceneGame v-else-if="scene === 'game' && battle"
                   :battle="battle"
                   :events="events"
                   :casters="casters"
                   :title="title"
                   :admin="admin"
                   :now="now"/>
      <MbScenePost v-else-if="scene === 'post' && postBattle" :battle="postBattle" :series="series" :admin="admin"/>
      <div v-else-if="admin" class="mbo-placeholder mbo-service">{{ missingText }}</div>
    </template>
    <div v-else-if="admin" class="mbo-placeholder mbo-service">Без графики — в эфире чистая картинка игры</div>
  </div>
</template>

<script>
import MbSceneDraft from '@/components/MlbbBroadcast/overlay/MbSceneDraft.vue'
import MbSceneGame from '@/components/MlbbBroadcast/overlay/MbSceneGame.vue'
import MbSceneIntro from '@/components/MlbbBroadcast/overlay/MbSceneIntro.vue'
import MbScenePost from '@/components/MlbbBroadcast/overlay/MbScenePost.vue'

/**
 * Графика эфира 1920×1080 на прозрачном фоне.
 * admin — режим превью в админке: шахматка вместо прозрачности, заглушки и служебные плашки,
 * которых нет в выводе для OBS.
 */
export default {
  name: 'MbOverlay',
  components: {MbSceneDraft, MbSceneGame, MbSceneIntro, MbScenePost},
  props: {
    scene: {type: String, default: 'none'},
    battle: {type: Object, default: null},
    // игра для «Итогов» — может быть не текущей игрой серии
    postBattle: {type: Object, default: null},
    events: {type: Array, default: () => []},
    series: {type: Array, default: () => []},
    casters: {type: Array, default: () => []},
    title: {type: String, default: ''},
    admin: {type: Boolean, default: false},
    now: {type: Number, default: () => Date.now()},
  },
  computed: {
    missingText() {
      if (this.scene === 'post') return this.battle ? 'Выберите завершённую игру для итогов' : 'Нет данных — выберите матч'
      return 'Нет данных — выберите матч'
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/mlbb-overlay.scss";
</style>
